export const hasPermission = (authUser, permissionName) =>
  !!authUser?.roles?.some((permission) => permission.name === permissionName || permission.name_id === permissionName);

export const hasAnyPermission = (authUser, permissionNames = []) =>
  permissionNames.some((permissionName) => hasPermission(authUser, permissionName));

export const hasAllPermissions = (authUser, permissionNames = []) =>
  permissionNames.every((permissionName) => hasPermission(authUser, permissionName));
